import { render, staticRenderFns } from "./translate-list.vue?vue&type=template&id=8bd9c8b6&scoped=true"
import script from "./translate-list.vue?vue&type=script&lang=ts"
export * from "./translate-list.vue?vue&type=script&lang=ts"
import style0 from "./translate-list.vue?vue&type=style&index=0&id=8bd9c8b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd9c8b6",
  null
  
)

export default component.exports